import React, { PureComponent, Children, cloneElement } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames/bind';

import styles from './Actions.styl';

const cx = classNames.bind(styles);

export default class Actions extends PureComponent {
  static defaultProps = {
    className: '',
    align: 'justify',
  };

  static propTypes = {
    className: PropTypes.string,
    align: PropTypes.oneOf(['left', 'center', 'right', 'justify']),
  };

  getAdditionalProps = props => ({
    ...props,
    className: cx('Actions__item', props.className),
  });

  getChildrenActionsWithProps = () => {
    return Children.map(this.props.children, child =>
      cloneElement(child, this.getAdditionalProps(child.props)),
    );
  };

  render() {
    const { align } = this.props;
    const actionsWithProps = this.getChildrenActionsWithProps();
    return (
      <div
        className={cx('Actions', this.props.className, {
          [`Actions_align_${align}`]: align,
        })}>
        {actionsWithProps}
      </div>
    );
  }
}
